"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledTheme = require("../../styles/styledTheme");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var selectStyles = {
  control: function control(base, _ref) {
    var isDisabled = _ref.isDisabled;
    return _objectSpread(_objectSpread({}, base), {}, {
      boxShadow: "none",
      borderRadius: 0,
      minHeight: '32px',
      border: "1px solid ".concat(_styledTheme.styledTheme.colors.grey500),
      fontSize: 14,
      '&:hover': {
        borderColor: _styledTheme.styledTheme.colors.main400
      },
      backgroundColor: isDisabled ? _styledTheme.styledTheme.colors.grey700 : 'white'
    });
  },
  placeholder: function placeholder(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      color: '#a2a2a2'
    });
  },
  dropdownIndicator: function dropdownIndicator(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      padding: 4
    });
  },
  clearIndicator: function clearIndicator(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      padding: 4
    });
  },
  multiValue: function multiValue(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      backgroundColor: _styledTheme.styledTheme.colors.main400
    });
  },
  valueContainer: function valueContainer(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      padding: '0px 6px'
    });
  },
  input: function input(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      margin: 0,
      padding: 0
    });
  },
  option: function option(base, state) {
    return _objectSpread(_objectSpread({}, base), {}, {
      boxShadow: "none",
      paddingLeft: 6,
      borderRadius: 0,
      fontSize: 14,
      backgroundColor: state.isSelected ? _styledTheme.styledTheme.colors.main : state.isFocused ? _styledTheme.styledTheme.colors.main400 : null,
      '&:hover': {
        backgroundColor: _styledTheme.styledTheme.colors.main400
      }
    });
  },
  menu: function menu(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      borderRadius: 0,
      marginTop: 0,
      maxHeight: 170,
      minWidth: 150,
      overflowY: 'auto',
      position: 'absolute',
      zIndex: 9999
    });
  },
  menuList: function menuList(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      maxHeight: 170
    });
  },
  color: function color(base) {
    return _objectSpread(_objectSpread({}, base), {}, {
      text: 'blue'
    });
  }
};
var _default = selectStyles;
exports.default = _default;